import { render, staticRenderFns } from "./parts-locations-general.vue?vue&type=template&id=24d402e8&scoped=true&"
import script from "./parts-locations-general.vue?vue&type=script&lang=js&"
export * from "./parts-locations-general.vue?vue&type=script&lang=js&"
import style0 from "./parts-locations-general.vue?vue&type=style&index=0&id=24d402e8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24d402e8",
  null
  
)

export default component.exports